/** Shared bounds/defaults for the desktop-web LeftPane/RightPane — single
 * source of truth so width isn't hardcoded independently across LeftPane,
 * RightPane, ScreenLayout's content margin, ConversationScreen's inset, and
 * Modal's content-area constraints (previously five separate literals that
 * had already drifted, 350 vs 355). */
export const PANE_MIN_WIDTH = 260;
export const PANE_MAX_WIDTH = 500;
export const PANE_DEFAULT_WIDTH = 350;
export const PANE_ANIMATION_DURATION = 200;
/** The right pane while it shows a conversation, call history or the AI
 * assistant: wide enough for message bubbles, cards and tables. */
export const PANE_WIDE_WIDTH = 560;
